import { FindManyBlogsDocument } from '@/types/graphql/types'
import { useQuery } from '@apollo/client'

const useBlog = ({ id }: { id?: number }) => {
  // fetch blogs data
  const { data } = useQuery(FindManyBlogsDocument, {
    variables: {
      where: {
        id: { equals: id },
      },
    },
  })

  return {
    data,
  }
}

export default useBlog
